'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  /* -moz-appearance: none; */\n  width: 100%;\n  border-radius: ', ';\n  /* -webkit-appearance: none; */\n  background-color: white;\n  border: 1px solid #aaa;\n  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 0.5em;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  background-image: url(\'data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2370af00%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\'),\n    linear-gradient(to bottom, #ffffff 0%, #fff 100%);\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.8em top 50%, 0 0;\n  background-size: 0.85em auto, 100%;\n  &:focus {\n    outline: none;\n  }\n  &::-moz-focus-inner {\n    outline: 0;\n  }\n  ', ' color: ', ';\n  font-family: ', ';\n  outline: 0;\n  padding-right: ', ';\n  &:focus {\n    outline: none;\n  }\n  &::-moz-focus-inner {\n    outline: 0;\n  }\n'], ['\n  /* -moz-appearance: none; */\n  width: 100%;\n  border-radius: ', ';\n  /* -webkit-appearance: none; */\n  background-color: white;\n  border: 1px solid #aaa;\n  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 0.5em;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  background-image: url(\'data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2370af00%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\'),\n    linear-gradient(to bottom, #ffffff 0%, #fff 100%);\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.8em top 50%, 0 0;\n  background-size: 0.85em auto, 100%;\n  &:focus {\n    outline: none;\n  }\n  &::-moz-focus-inner {\n    outline: 0;\n  }\n  ', ' color: ', ';\n  font-family: ', ';\n  outline: 0;\n  padding-right: ', ';\n  &:focus {\n    outline: none;\n  }\n  &::-moz-focus-inner {\n    outline: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n  svg {\n    width: ', ';\n    height: ', ';\n  }\n'], ['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n  svg {\n    width: ', ';\n    height: ', ';\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n'], ['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Loader = require('../Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Select = _styledComponents2.default.select(_templateObject, (0, _polished.rem)(2), function (props) {
  switch (props.size) {
    case 's':
      return '\n          padding: 0 ' + (0, _polished.rem)(15) + ';\n          font-size: ' + function (_ref) {
        var theme = _ref.theme;
        return theme.font.fontSizeXS;
      } + ';\n          height: ' + (0, _polished.rem)(40) + ';\n          ';
      break;
    case 'xs':
      return '\n          padding: 0 ' + (0, _polished.rem)(10) + ' 0 ' + (0, _polished.rem)(15) + ';\n          font-size: ' + function (_ref2) {
        var theme = _ref2.theme;
        return theme.font.fontSizeS;
      } + ';\n          height: ' + (0, _polished.rem)(34) + ';\n          ';
      break;
    default:
      return '\n        font-size: ' + function (_ref3) {
        var theme = _ref3.theme;
        return theme.font.fontSizeXS;
      } + ';\n          padding: 0 ' + (0, _polished.rem)(21) + ';\n          height: ' + (0, _polished.rem)(50) + ';\n        ';
  }
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.textColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font.fontFamily;
}, function (_ref6) {
  var loading = _ref6.loading;
  return loading ? (0, _polished.rem)(60) : (0, _polished.rem)(15);
});

var Wrapper = _styledComponents2.default.div(_templateObject2);

var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject3, (0, _polished.rem)(15), (0, _polished.rem)(16), (0, _polished.rem)(16));

var StyledLoader = _styledComponents2.default.div(_templateObject4, (0, _polished.rem)(15));

var CompSelect = function (_PureComponent) {
  _inherits(CompSelect, _PureComponent);

  function CompSelect() {
    _classCallCheck(this, CompSelect);

    return _possibleConstructorReturn(this, (CompSelect.__proto__ || Object.getPrototypeOf(CompSelect)).apply(this, arguments));
  }

  _createClass(CompSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['className']);

      return _react2.default.createElement(
        Wrapper,
        { className: className },
        _react2.default.createElement(Select, _extends({}, restProps, {
          innerRef: this.props.inputRef,
          id: this.props.id || this.context.id,
          size: this.props.size,
          haveIcon: !!this.props.icon,
          loading: !!this.props.loading
        })),
        this.props.loading && _react2.default.createElement(
          StyledLoader,
          null,
          _react2.default.createElement(_Loader2.default, null)
        )
      );
    }
  }]);

  return CompSelect;
}(_react.PureComponent);

CompSelect.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  inputRef: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(['xs', 's', 'm']),
  icon: _propTypes2.default.string,
  loading: _propTypes2.default.bool
};

CompSelect.defaultProps = {
  className: '',
  id: null,
  inputRef: function inputRef() {},
  size: 'm',
  icon: null,
  loading: false
};

CompSelect.contextTypes = {
  id: _propTypes2.default.string
};

exports.default = CompSelect;
CompSelect.__docgenInfo = [{
  'description': '',
  'displayName': 'CompSelect',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'inputRef': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'size': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'xs\'',
          'computed': false
        }, {
          'value': '\'s\'',
          'computed': false
        }, {
          'value': '\'m\'',
          'computed': false
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'m\'',
        'computed': false
      }
    },
    'icon': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'loading': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  },
  'context': {
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Select/index.js'] = {
    name: 'CompSelect',
    docgenInfo: CompSelect.__docgenInfo,
    path: 'src/Select/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Select/index.js
// module id = 86
// module chunks = 1